import PropTypes from "prop-types";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import ProductTypeItem from "../ProductTypeItem";

const SortableItem = SortableElement(
  ({
    value,
    handleSelectedItem,
    selectedItem,
    itemId,
    itemIndex,
    totalItems,
    columnsPerRow,
    handleDeleteTypeProduct,
    onMoveItem,
  }) => (
    <ProductTypeItem
      item={value}
      itemId={itemId}
      itemIndex={itemIndex}
      totalItems={totalItems}
      columnsPerRow={columnsPerRow}
      selectedItem={selectedItem}
      handleDeleteTypeProduct={handleDeleteTypeProduct}
      handleSelectedItem={handleSelectedItem}
      onMoveItem={onMoveItem}
    />
  )
);
SortableItem.propTypes = {
  selectedItem: PropTypes.object,
  itemId: PropTypes.string,
  itemIndex: PropTypes.number,
  totalItems: PropTypes.number,
  columnsPerRow: PropTypes.number,
  handleDeleteTypeProduct: PropTypes.func,
  handleSelectedItem: PropTypes.func,
  onMoveItem: PropTypes.func,
  value: PropTypes.object,
};

const SortableList = (props) => {
  const {
    items,
    handleDeleteTypeProduct,
    handleSelectedItem,
    onMoveItem,
    columnsPerRow = 3,
    ...restProps
  } = props;

  return (
    <div className="sortable-list-wrapper">
      {items.map((item, index) => (
        <SortableItem
          key={`item-${item._id}`}
          index={index}
          itemIndex={index}
          totalItems={items.length}
          columnsPerRow={columnsPerRow}
          value={item}
          itemId={item._id}
          handleDeleteTypeProduct={handleDeleteTypeProduct}
          handleSelectedItem={handleSelectedItem}
          onMoveItem={onMoveItem}
          {...restProps}
        />
      ))}
    </div>
  );
};
SortableList.propTypes = {
  items: PropTypes.array,
  handleDeleteTypeProduct: PropTypes.func,
  handleSelectedItem: PropTypes.func,
  onMoveItem: PropTypes.func,
  columnsPerRow: PropTypes.number,
};
export default SortableContainer(SortableList);
